import { makeStyles } from '@material-ui/core/styles';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import { rem } from 'src/common/helpers/dimension-helper';

const customFontSize: CSSProperties = {
  fontSize: rem(1),
  '@media (width: 1024px) and (height: 576px)': {
    fontSize: rem(0.875),
  },
  '@media (width: 1024px) and (height: 768px)': {
    fontSize: rem(0.9),
  },
  '@media (width: 1600px) and (height: 900px)': {
    fontSize: rem(1.125),
  },
  '@media (width: 1600px) and (height: 1200px)': {
    fontSize: rem(1.375),
  },
  '@media (width: 1920px) and (height: 1080px)': {
    fontSize: rem(1.5),
  },
};

export const styles = makeStyles(() => ({
  summaryContainer: {
    ...customFontSize,
    width: 'auto',
    padding: '1vh 1vw',
    lineHeight: '3.125vh',
    fontWeight: 500,
  },
  summaryMargin: {
    marginBottom: '1.5vh',
  },
  summaryHeading: {
    width: 'auto',
    textTransform: 'uppercase',
  },
  summaryValue: {
    ...customFontSize,
    paddingLeft: '1vw',
    '@media  (width: 1024px) and (height: 768px)': {
      padding: 0,
    },
  },
}));
